import Swiper from 'swiper';

// Create a new employeeRoll object
class tabs5050 {
  constructor() {
    this.swiper = new Swiper('.swiper.tabs-content', {
      direction: 'horizontal',
      speed: 0,
      slidesPerView: 1,
      simulateTouch: false,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
          var pagination = $(this.el).find('.swiper-pagination');
          var title = $(pagination).data('tab-' + (index + 1) + '-title');
          return '<span class="tab-title ' + className + '">' + title + '</span>'
        },
      },
    });
  }

  init () {
    this.swiper.init();
  }
}

// Export class as default
export default tabs5050;



// WEBPACK FOOTER //
// ./scripts/components/tabs5050.js